var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Label',{attrs:{"tipo":_vm.definirTipo(_vm.tipo, _vm.elegivel),"estilo":_vm.definirEstilo(_vm.elegivel),"texto":_vm.definirRenovabio(_vm.elegivel)}})
}
var staticRenderFns = []

export { render, staticRenderFns }